module.exports = __webpack_public_path__ + "img/liaowangtaSel.c4808930.png";